var map = {
	"./1.png": 53189,
	"./2.png": 36870,
	"./3.png": 24102,
	"./4.png": 71681,
	"./5.png": 54037,
	"./6.png": 26370,
	"./Slice 9.png": 45591,
	"./Slice.png": 25354,
	"./about-us/brand/team-photo.jpeg": 86071,
	"./about-us/hero.png": 77663,
	"./about-us/partners/中南大学湘雅医院.png": 72417,
	"./about-us/partners/中国人民解放军总医院.jpeg": 64947,
	"./about-us/partners/中国医学科学院肿瘤医院.png": 67699,
	"./about-us/partners/中国医科大学附属第一医院.png": 31458,
	"./about-us/partners/中山大学肿瘤防治中心.jpeg": 10634,
	"./about-us/partners/北京协和医院.png": 51491,
	"./about-us/partners/华中科技大学同济医学院附属同济医院.jpg": 68153,
	"./about-us/partners/南方医科大学南方医院.png": 23286,
	"./about-us/partners/厦门大学附属第一医院.png": 6959,
	"./about-us/partners/复旦大学附属中山医院.png": 59857,
	"./about-us/partners/复旦大学附属华山医院.png": 96277,
	"./about-us/partners/江苏省人民医院.png": 719,
	"./about-us/partners/浙江大学医学院附属第二医院.jpg": 29346,
	"./about-us/partners/浙江省中医院.png": 2343,
	"./about-us/partners/空军军医大学西京医院.png": 40505,
	"./about-us/partners/陆军军医大学西南医院.jpeg": 4121,
	"./ali-pay.png": 27832,
	"./banner-1.jpg": 61150,
	"./banner-2.jpg": 90403,
	"./banner1.jpg": 82464,
	"./banner2.jpg": 72523,
	"./bg_buy_one.png": 90126,
	"./bg_customer.png": 70175,
	"./bg_customer_line.png": 25135,
	"./bg_customer_line2.png": 38426,
	"./bg_customer_service.png": 11643,
	"./bg_exchange_success.png": 5254,
	"./bg_exchange_success_line.png": 86663,
	"./bg_home_banner.png": 32353,
	"./bg_home_banner_title.png": 19743,
	"./bg_login.png": 62098,
	"./bg_pay_success.png": 20654,
	"./bg_pay_success1.png": 42993,
	"./bg_vip.png": 42251,
	"./bg_vip_tab_check.png": 71056,
	"./block.png": 62042,
	"./category/1.png": 74635,
	"./category/2.png": 31466,
	"./category/3.png": 27390,
	"./category/4.png": 69284,
	"./category/5.png": 64997,
	"./category/6.jpg": 86715,
	"./category/7.jpg": 11193,
	"./category/8.jpg": 48039,
	"./close.png": 42266,
	"./contact-bg1.png": 68821,
	"./contact-bg2.png": 26219,
	"./contact-bg3.png": 90308,
	"./custom-service/10.jpeg": 8463,
	"./custom-service/8.jpeg": 15911,
	"./custom-service/9.jpeg": 23821,
	"./custom-service/hero.png": 60669,
	"./custom-service/service-wechat.png": 55547,
	"./custom-service/好评截图1.jpeg": 3777,
	"./custom-service/好评截图2.jpeg": 86126,
	"./custom-service/好评截图3.jpeg": 81127,
	"./custom-service/好评截图4.jpeg": 44719,
	"./custom-service/好评截图5.jpeg": 15336,
	"./custom-service/好评截图6.jpeg": 72120,
	"./custom-service/好评截图7.jpeg": 920,
	"./customer_wxqr.png": 11381,
	"./customer_wxqr1.png": 7920,
	"./default.png": 15865,
	"./detail/bg_check.png": 98570,
	"./detail/icon_down.png": 48955,
	"./detail/icon_last.png": 92420,
	"./detail/icon_next.png": 73730,
	"./detail/icon_play-video.png": 69739,
	"./detail/icon_share.png": 38617,
	"./detail/icon_star.png": 11866,
	"./detail/icon_vip-free.png": 54857,
	"./detail/icon_vip.png": 19078,
	"./finger.png": 27879,
	"./home_bg.png": 29382,
	"./icon__customer.png": 30093,
	"./icon__recommend.png": 49986,
	"./icon__wechat-white.png": 19605,
	"./icon_alipay.png": 13780,
	"./icon_alipay_1.png": 31219,
	"./icon_avatar.png": 90704,
	"./icon_check.png": 44170,
	"./icon_check2.png": 94181,
	"./icon_close.png": 4461,
	"./icon_copy.png": 1396,
	"./icon_custom_made.png": 68351,
	"./icon_customer_check.png": 13589,
	"./icon_customer_logo.png": 36041,
	"./icon_customer_service.png": 58018,
	"./icon_customer_star.png": 37663,
	"./icon_exchange_code.png": 73829,
	"./icon_lihua.png": 85642,
	"./icon_lock.png": 72975,
	"./icon_logo.png": 90999,
	"./icon_m_logo.png": 69098,
	"./icon_mobile_logo.png": 33151,
	"./icon_open_vip.png": 17948,
	"./icon_pay_success.png": 72036,
	"./icon_pc.png": 61850,
	"./icon_search.png": 49673,
	"./icon_search2.png": 12529,
	"./icon_wepay.png": 28574,
	"./icon_wepay_1.png": 22669,
	"./icon_wepay_2.png": 69276,
	"./icon_wexin.png": 52443,
	"./logo-2.png": 15995,
	"./logo_mobile_drawer_icon.png": 64530,
	"./menber_bg.png": 86194,
	"./mobile-about-us/brand/intro-team.jpeg": 25577,
	"./mobile-about-us/hero.png": 60068,
	"./mobile-about-us/partners/中南大学湘雅医院.png": 75740,
	"./mobile-about-us/partners/中国人民解放军总医院.jpeg": 75319,
	"./mobile-about-us/partners/中国医学科学院肿瘤医院.png": 74122,
	"./mobile-about-us/partners/中国医科大学附属第一医院.png": 60979,
	"./mobile-about-us/partners/中山大学肿瘤防治中心.jpeg": 51490,
	"./mobile-about-us/partners/北京协和医院.png": 46834,
	"./mobile-about-us/partners/华中科技大学同济医学院附属同济医院.jpg": 25913,
	"./mobile-about-us/partners/南方医科大学南方医院.png": 74024,
	"./mobile-about-us/partners/厦门大学附属第一医院.png": 81403,
	"./mobile-about-us/partners/复旦大学附属中山医院.png": 15818,
	"./mobile-about-us/partners/复旦大学附属华山医院.png": 56600,
	"./mobile-about-us/partners/江苏省人民医院.png": 42049,
	"./mobile-about-us/partners/浙江大学医学院附属第二医院.jpg": 70445,
	"./mobile-about-us/partners/浙江省中医院.png": 31666,
	"./mobile-about-us/partners/空军军医大学西京医院.png": 17148,
	"./mobile-about-us/partners/陆军军医大学西南医院.jpeg": 46858,
	"./mobile-custom-service/customer-service.png": 70214,
	"./mobile-custom-service/hero.png": 58968,
	"./mobile-custom-service/service-wechat.png": 36634,
	"./mobile-custom-service/testimonials/10.jpeg": 30784,
	"./mobile-custom-service/testimonials/8.jpeg": 78055,
	"./mobile-custom-service/testimonials/9.jpeg": 82535,
	"./mobile-custom-service/testimonials/好评截图1.jpeg": 11593,
	"./mobile-custom-service/testimonials/好评截图2.jpeg": 99596,
	"./mobile-custom-service/testimonials/好评截图3.jpeg": 51356,
	"./mobile-custom-service/testimonials/好评截图4.jpeg": 46817,
	"./mobile-custom-service/testimonials/好评截图5.jpeg": 71024,
	"./mobile-custom-service/testimonials/好评截图6.jpeg": 15775,
	"./mobile-custom-service/testimonials/好评截图7.jpeg": 67261,
	"./mobile/ad-zsjy.png": 2554,
	"./mobile/ad.png": 44612,
	"./mobile/home.png": 96754,
	"./mobileLine.png": 53977,
	"./month.png": 66136,
	"./month_bg.png": 46155,
	"./month_year.png": 79722,
	"./no-data.png": 76977,
	"./open-vip/bg_buy_month.png": 55444,
	"./open-vip/bg_buy_month2.png": 34931,
	"./open-vip/bg_buy_month2_check.png": 4405,
	"./open-vip/bg_buy_month_check.png": 43318,
	"./open-vip/bg_buy_one.png": 99735,
	"./open-vip/bg_buy_one_check.png": 79436,
	"./open-vip/bg_buy_week.png": 5064,
	"./open-vip/bg_buy_week_check.png": 14116,
	"./open-vip/bg_buy_year.png": 73203,
	"./open-vip/bg_buy_year2.png": 91014,
	"./open-vip/bg_buy_year2_check.png": 62926,
	"./open-vip/bg_buy_year_check.png": 47244,
	"./open-vip/bg_check.png": 58821,
	"./open-vip/bg_modal.png": 71263,
	"./pay-success-bg.png": 7865,
	"./pay-success-bg1.png": 88754,
	"./pay-success-bg2.png": 134,
	"./pay-success-bg3.png": 68645,
	"./paying-bg.png": 52500,
	"./star.png": 76960,
	"./user.png": 44353,
	"./vip-upgrade/mobile-hero-bg.png": 11252,
	"./vip-upgrade/mobile-vip-crown.png": 40436,
	"./vip-upgrade/pc-feature-designer.png": 79791,
	"./vip-upgrade/pc-feature-medical.png": 31491,
	"./vip-upgrade/pc-feature-original.png": 16829,
	"./vip-upgrade/pc-feature-secure.png": 87428,
	"./vip-upgrade/pc-mastergo-hero.png": 3636,
	"./vip.png": 57159,
	"./vipcard/bg_1.png": 66935,
	"./vipcard/bg_2.png": 39414,
	"./vipcard/bg_3.png": 22043,
	"./vipcard/icon_1.svg": 8825,
	"./vipcard/icon_2.svg": 37789,
	"./vipcard/icon_3.svg": 70197,
	"./vipcard/icon_4.svg": 64777,
	"./vipcard/icon_5.svg": 12606,
	"./vipcard/icon_6.svg": 31797,
	"./wechat-pay.png": 5878,
	"./week_slice.png": 27237,
	"./year.png": 35351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;